var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlind = function SvgBlind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "M31.177 31.294H8.59a3.767 3.767 0 0 1-3.766-3.767V8.706h26.353z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "blind_svg__a",
    width: 32,
    height: 28,
    x: 2,
    y: 4,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 31.294h32V4H2z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#blind_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8.706h32V4H2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.836 24.595h1.882V5.003h-1.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.66 23.653a1.883 1.883 0 1 1-3.767-.001 1.883 1.883 0 0 1 3.766.001"
  }))));
};
export default SvgBlind;